import '../App.css';
import MainContent from '../components/MainContent';
import { MouseEventHandler, useEffect, useRef, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, FormWhiteContainer, LabelContainer, LightBlueContainer, ShortBlueButton, WhiteContainer } from '../assets/style';
import SearchInput from '../components/SearchInput';
import dayjs, { Dayjs } from 'dayjs';
import SearchDatePicker from '../components/SearchDatePicker';
import FormButton from '../components/FormButton';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import axios from 'axios';
import FormInput from '../components/FormInput';
import FormDatePicker from '../components/FormDatePicker';
import React from 'react';
import FormLabel from '../components/FormLabel';
import { height, minWidth } from '@mui/system';
import FormCheckbox from '../components/FormCheckbox';
import { useLocation, useNavigate } from 'react-router';
import { workerPageName } from '../components/PageName';
import { useLazyGetWorkerDetailQuery, useLazyGetWorkerFileQuery } from '../features/worker/workerSlice';
import { SafetyRelatedCert, WorkerDetailModel, trainingDetail } from '../models/WorkerModel';
import { useTranslation } from "react-i18next";

const WorkerDetailPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    const workerId = getLocation.state?.workerID;
    const [worker, setWorker] = useState<WorkerDetailModel | null>(null);
    const [getWorkerDetail, getWorkerDetailResult] = useLazyGetWorkerDetailQuery()
    const [getWorkerFile, getWorkerFileResult] = useLazyGetWorkerFileQuery()
    console.log("workerId, ", workerId)
    useEffect(() => {
        if (workerId) {
            getWorkerDetail(workerId)
        }
    }, [])

    useEffect(() => {
        if (getWorkerDetailResult.isSuccess) {
            setWorker(getWorkerDetailResult.data)
        }
    }, [getWorkerDetailResult.data])

    //Todo: Handle failures to get worker detail
    useEffect(() => { })

    const getLink = function (safetyRelatedCert: SafetyRelatedCert | null | undefined) {
        if (safetyRelatedCert) {
            return <a
                onClick={async () => { await getFile(safetyRelatedCert.Id, safetyRelatedCert.Name, safetyRelatedCert.ContentType) }}
                href={"javascript:;"}
                target="_self"
                rel="noopener noreferrer"
            >
                {safetyRelatedCert.Name}
            </a>
        } else {
            return "None"
        }
    }

    const getFile = async function (fileId: string, filename: string, contentType: string) {
        try {
            const dataUrl = await getWorkerFile(fileId).unwrap()
            const blob = await fetch(dataUrl).then(r => r.blob());
            const file = new File([blob], filename, { type: contentType });
            displayImageInNewTab(file, filename)
        } catch (error) {
            alert("fails to open the file.")
            console.error(error)
            navigate('/worker-detail', { state: { workerID: workerId } })
        } finally {

        }
    }

    const displayImageInNewTab = function (blob: Blob, filename: string) {
        const imageUrl = URL.createObjectURL(blob);
        const newTab = window.open(imageUrl);
    }

    return (
        <MainContent type={workerPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <BigHeading>{t("Worker Detail")}</BigHeading>
                    <ShortBlueButton onClick={() => { navigate('/add-worker', { state: { worker } }); }}>Edit</ShortBlueButton>
                    {/* <FormLabel title={t("RFID No.")} value={worker?.rfidNumber} /> */}
                    <FormLabel title={t("Worker Name")} value={worker?.workerName} />
                    <FormLabel title={t("Company Name")} value={worker?.companyName} />
                    <FormLabel title={t("Phone Number")} value={worker?.phoneNumber} />
                    {<FormLabel title={t("Worker Photo")} value={getLink(worker?.workerPhotoFile)} />}
                    <FormLabel title={t("Worker Registration Card")} value={getLink(worker?.registrationCardFile)} />
                    <FormLabel title={t("Safety Card")} value={getLink(worker?.safetyCardFile)} />
                    <FormLabel title={t("Certified Work of Confined Space Operation")} value={getLink(worker?.certifiedConfinedWorkFile)} />
                    <BigHeading>{t("Training Details")}</BigHeading>
                    {worker?.trainingDetails?.length && worker?.trainingDetails?.length > 0 ? (
                        worker?.trainingDetails.map((cert: trainingDetail) => (
                            <FormWhiteContainer key={cert?.id}>
                                <div style={{ margin: "10px" }}>
                                    &nbsp;
                                    <FormLabel
                                        title={"Training Date"}
                                        value={cert?.trainingDate}

                                    />
                                    <FormLabel title={"Training Certificate"} value={cert?.certificationName} />
                                    <FormLabel
                                        title={"Attachments"}
                                        value={getLink(cert.certificationFile)}
                                    />
                                </div>
                                &nbsp;
                            </FormWhiteContainer>
                        ))
                    ) : (
                        <FormWhiteContainer><p style={{ marginLeft: "28px" }}>{t("No certificates found.")}</p></FormWhiteContainer>
                    )}

                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        {/* <ShortBlueButton >{t("Save")}</ShortBlueButton> */}
                        <BackButton onClick={() => { navigate('/worker') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default WorkerDetailPage;